import React from "react";
import { PROSPECT_STATUSES, DOSSIER_STATUSES, FINANCEMENT_STATUSES, DENONCIATION_STATUSES, OPTION_STATUSES, FACTURE_STATUSES } from "@/lib/api";

const STATUS_MAPS = {
  prospect: PROSPECT_STATUSES,
  dossier: DOSSIER_STATUSES,
  financement: FINANCEMENT_STATUSES,
  denonciation: DENONCIATION_STATUSES,
  option: OPTION_STATUSES,
  facture: FACTURE_STATUSES,
};

const FALLBACK_COLORS = {
  a_traiter: "text-amber-700 bg-amber-50 border-amber-200",
  envoyee: "text-blue-700 bg-blue-50 border-blue-200",
  demandee: "text-blue-700 bg-blue-50 border-blue-200",
  acceptee: "text-emerald-700 bg-emerald-50 border-emerald-200",
  accordee: "text-emerald-700 bg-emerald-50 border-emerald-200",
  refusee: "text-red-700 bg-red-50 border-red-200",
  refuse: "text-red-700 bg-red-50 border-red-200",
  en_attente: "text-amber-700 bg-amber-50 border-amber-200",
  en_cours: "text-blue-700 bg-blue-50 border-blue-200",
  obtenu: "text-emerald-700 bg-emerald-50 border-emerald-200",
  a_emettre: "text-amber-700 bg-amber-50 border-amber-200",
  payee: "text-emerald-700 bg-emerald-50 border-emerald-200",
  en_retard: "text-red-700 bg-red-50 border-red-200",
  signe: "text-emerald-700 bg-emerald-50 border-emerald-200",
  cloture: "text-slate-700 bg-slate-100 border-slate-300",
};

export default function StatusBadge({ value, kind = "prospect" }) {
  if (!value) return <span className="text-xs text-slate-400">—</span>;
  const list = STATUS_MAPS[kind] || [];
  const found = list.find((s) => s.value === value);
  const label = found?.label || value;
  const color = found?.color || FALLBACK_COLORS[value] || "text-slate-700 bg-slate-100 border-slate-300";
  return (
    <span className={`badge-status ${color}`} data-testid={`badge-${value}`}>{label}</span>
  );
}
